module.exports = __webpack_public_path__ + "9342b4baf2892c45ca901a74eca2448c.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/header/shaffi11-large.jpg
// module id = k1am
// module chunks = 0